
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./graphql-scala-4-deferred-resolvers.json") })
        }
      }, "path---graphql-scala-4-deferred-resolvers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---graphql-scala-4-deferred-resolvers!./.cache/json/graphql-scala-4-deferred-resolvers.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---graphql-scala-4-deferred-resolvers!./.cache/json/graphql-scala-4-deferred-resolvers.json
// module chunks = 154